export enum routerPathMain {
    ADD ='/them-moi',
    EDIT ='/cap-nhat',
    UPGRADE ='/nang-cap',
    VIEW ='/xem-chi-tiet',
    GROUP ='/ben-tham-gia',
    POSITION ='/dat-vi-tri',
    NUMBERED = '/danh-so',
    MY_DOCUMENT='/my-document',
    CONTRACT_SIGN='/hop-dong-can-ky',
    CONTRACT_DOCUMENT_SIGN='/ho-so-hop-dong-can-ky',
    DOC_SIGN='/van-ban-can-ky',
    DUPLICATE_CONTRACT='/ban-sao-hop-dong',
    DUPLICATE_CONTRACT_DOCUMENT='/ban-sao-ho-so-hop-dong',
    DUPLICATE_SUBMISSION='/ban-sao-van-ban',
    DUPLICATE_DOC='/ban-sao-tai-lieu',
    END='/ket-thuc',
    SEARCH='/search',
    PDF='/pdf',
    BATCH_SIGNER_ADD="/them-moi-trinh-ky-theo-lo",
    BATCH_SIGNER_VIEW="/xem-chi-tiet-trinh-ky-theo-lo",
    BATCH_SIGNER_EDIT="/cap-nhat-trinh-ky-theo-lo",
    QUICK_SIGNER_ADD="/them-moi-trinh-ky-nhanh",
    QUICK_SIGNER_EDIT="/cap-nhat-trinh-ky-nhanh",
    LOT="/ky-lo",
    STOP_EFFECT = "/dung-hieu-luc"
}
